import { useAxios } from "@/hooks/useAxios";
import { API_BUILDING_NAME } from "@/types/endpoint";

type IUpload = {
  building_name: string;
};

type IDownload = {
  status: string | null;
  message: string | null;
  result: {
    address: {
      chome_id: string;
      full: string;
    };
    name: string;
  }[];
};

type IStored = {
  label: string;
  value: string;
}[];

function processing(downloaded: IDownload) {
  const { result } = downloaded;
  let stored: IStored = [];
  stored = result.map((x) => {
    return {
      label: x.name,
      value: x.address.full,
    };
  });
  stored = stored.filter((item, index, self) => {
    // label だけをリスト化する
    const labelList = self.map((item) => item.label);
    // 重複を削除する
    if (labelList.indexOf(item.label) === index) {
      return item;
    }
  });
  return stored;
}

export const useBuildingAutocomplete = () => {
  return useAxios<IUpload, IDownload, IStored>(API_BUILDING_NAME, processing);
};
